import BaseModelAPI from '../BaseModelAPI';

export default class PartDestinationList extends BaseModelAPI {

	static entity = 'partdestinationlist'
	static entityName = 'partdestination';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
